/** задержка первой анимации после mount - ms */
export const mountDelay = 500;
/** пустой пробел */
export const noWidthSpace = '\ufeff';

export const FIELD_NAME = 'field';
export const PARAM_NAME = 'param';
export const PERCENT_NAME = 'percent';
export const SEPARATOR = '#';
